import script from "./goRinSyo0080.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0080.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0080.vue?vue&type=style&index=0&id=3caf7584&lang=scss"

const __exports__ = script;

export default __exports__